/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type UsersInteractionsFilterConfigColumn =
  (typeof UsersInteractionsFilterConfigColumn)[keyof typeof UsersInteractionsFilterConfigColumn];

export const UsersInteractionsFilterConfigColumn = {
  users_interactions: 'users_interactions',
} as const;
